import {
  RESEND_CONFIRMACC_REQUESTING,
  } from './constants'
  
export const resendConfirmAccRequest = function resendConfirmAccRequest (formData) {
  return {
    type: RESEND_CONFIRMACC_REQUESTING,
    formData,
  }
}
  
export default resendConfirmAccRequest


// WEBPACK FOOTER //
// ./src/views/Pages/ResendConfirmAcc/actions.js